/* Copyright (c) 2017 Backpack Health LLC */
/* global window */

import { types as navigationActionTypes } from 'redux/actions/navigation';

const selectors = {
  getHistory: (state) => state.navigation.pageHistory,
};

const initialState = {
  pageHistory: [],
};

function createPageHistoryFromLocationChange(currentPageHistory, payload) {
  const newPageHistory = currentPageHistory.map(a => a);

  switch (payload.action) {
    case 'PUSH':
      newPageHistory.push(payload.location);
      break;
    case 'POP':
      newPageHistory.pop();
      break;
    default:
      break;
  }
  return newPageHistory;
}

export function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case navigationActionTypes.GO_TO:
      state.pageHistory.push(action.payload);
      return _.assign({}, {
        pageHistory: state.pageHistory,
      });
    case navigationActionTypes.SET_HISTORY:
      return _.assign({}, {
        pageHistory: action.payload,
      });
    case navigationActionTypes.REACT_ROUTER_INIT:
      return _.assign({}, {
        pageHistory: [{
          pathname: window.location.pathname,
          state: {},
        }],
      });
    case navigationActionTypes.REACT_ROUTER_LOCATION_CHANGE:
      return _.assign({}, {
        pageHistory: createPageHistoryFromLocationChange(state.pageHistory, action.payload),
      });
    default:
      return state;
  }
}

export default selectors;
